package com.parmartechnologies.core.feature.cart.event

enum class CartEvent(val value: String) {
    GENERATE_CUSTOMER_INVOICE("GENERATE_CUSTOMER_INVOICE"),
    RETRIVE_SINGLE_INVOICE("RETRIVE_SINGLE_INVOICE"),
    RETRIEVE("RETRIEVE_INVOICE"),
}